export const getFiltersParams = selectedFilters => {
  return selectedFilters.length
    ? '?' + selectedFilters.map(filter => `body_parts[]=${filter.id}`).join('&')
    : '';
};
